export default __webpack_public_path__ + "media/images/home/nl/preview-5-bfbe1e058ef48677fef06092c400098b.jpg";